import React, { useEffect, useState } from 'react';
import { Tooltip } from 'reactstrap';

const TooltipCustom = (props) => {
    // const { tooltipText } = props;
    const tooltipText = (
        <div>
            <table border={0} cellPadding={3}>
                {/* <tr>  f = Coefficient of friction </tr> */}
                <tr>
                    <td align={'left'}>Metal to Metal </td>
                    <td align={'left'}>=</td>
                    <td>0.35</td>
                </tr>
                <tr>
                    <td align={'left'}>UHMWPE to Rubber </td>
                    <td align={'left'}>=</td>
                    <td>0.20</td>
                </tr>
                <tr>
                    <td align={'left'}>Rubber to Metal </td>
                    <td align={'left'}>=</td>
                    <td>1.00</td>
                </tr>
                <tr>
                    <td align={'left'}>UHMWPE to Metal </td>
                    <td align={'left'}>=</td>
                    <td>0.20</td>
                </tr>
            </table>
        </div>
    );
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    const [nu_id, setNu_id] = useState("");
    let u_id;

    useEffect(() => {
        u_id = Math.floor(Math.random() * 101);
        setNu_id(u_id);
    }, [])

    return (
        <>
            <i class="fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3" id={`A_${nu_id}_A`}></i>
            <Tooltip placement="top" isOpen={tooltipOpen} target={`A_${nu_id}_A`} toggle={toggle}>{tooltipText}</Tooltip>
        </>
    );
}

export default TooltipCustom;